import GetPricingMapper from '@/modules/health/common/mappers/MID/GetPricingMapper'
import GetProductsMapper from '@/modules/health/common/mappers/DXP/GetProductsMapper'
import GetMaxAgeMapper from '@/modules/health/common/mappers/DXP/GetMaxAgeMapper'

export default {
  GetPricingMapper,
  GetProductsMapper,
  GetMaxAgeMapper
}
